import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useStorage from 'hooks/useStorage';
import MaintenanceContext from 'contexts/MaintenanceContext';
import { isTestPath } from 'services/testMode';

const BYPASS_STORAGE_KEY = 'maintenanceBypass';

// The /test bypass only takes effect while the visitor is currently on the
// Insel network (161.62.0.0/16). The raw flag lives in sessionStorage so
// /test remembers a visitor opted in, but every consumer gets it AND-ed with
// the live isInsel status, so leaving the network turns the bypass off
// immediately instead of leaving it stuck on for the rest of the session.
// The flag is also destroyed outright as soon as the visitor navigates away
// from /test, so it can never be resurrected from storage later.
function useMaintenanceBypass() {
    const [bypass, setBypass] = useStorage<boolean>(BYPASS_STORAGE_KEY, false, { storage: sessionStorage });
    const maintenanceData: any = useContext(MaintenanceContext);
    const location = useLocation();

    useEffect(() => {
        if (!isTestPath(location.pathname) && bypass) {
            setBypass(false);
        }
        // eslint-disable-next-line
    }, [location.pathname]);

    return [bypass && maintenanceData.isInsel, setBypass] as [boolean, typeof setBypass];
}

export default useMaintenanceBypass;
